// ---------------------------------------------------------------------------
// cogibulle diffusion — Collections locales du diffuseur
// ---------------------------------------------------------------------------

import { Mongo } from 'meteor/mongo';

export const DiffusionNodeState = new Mongo.Collection ('diffusion_node_state');
export const DiffusionGames = new Mongo.Collection ('diffusion_games');
export const DiffusionVersions = new Mongo.Collection ('diffusion_versions');
export const DiffusionAliases = new Mongo.Collection ('diffusion_aliases');
export const DiffusionAssets = new Mongo.Collection ('diffusion_assets');
export const DiffusionAccessPolicies = new Mongo.Collection ('diffusion_access_policies');
export const DiffusionUserProjectAccess = new Mongo.Collection ('diffusion_user_project_access');
export const DiffusionUserSessions = new Mongo.Collection ('diffusion_user_sessions');
export const DiffusionPlaySessions = new Mongo.Collection ('diffusion_play_sessions');
// Consentements au suivi marketing, indexés par hash d'e-mail : posés à la
// demande du lien de connexion, consultés pour les envois serveur (CAPI).
export const DiffusionPixelConsents = new Mongo.Collection ('diffusion_pixel_consents');
// Journal des échanges serveur (CAPI Meta, Shopify) : tampon local purgé par
// la récolte du hub, avec TTL de sécurité de 24 h.
export const DiffusionSuiviLogs = new Mongo.Collection ('diffusion_suivi_logs');

// Miroir read-only du modèle hub. Ces collections permettent de porter le
// runtime lecture réel sans réinventer ses contrats de données.
export const Projets = new Mongo.Collection ('projets');
export const HubUsers = new Mongo.Collection ('hub_users');
export const Scenes = new Mongo.Collection ('scenes');
export const DiffusionSceneAccess = new Mongo.Collection ('diffusion_scene_access');
export const Cartes = new Mongo.Collection ('cartes');
export const HypeWidgets = new Mongo.Collection ('hypeWidgets');
export const HubFiles = new Mongo.Collection ('hubFiles');
export const VoiceProfiles = new Mongo.Collection ('voiceProfiles');
export const Seeds = new Mongo.Collection ('seeds');
export const Generations = new Mongo.Collection ('generations');
export const Instructions = new Mongo.Collection ('hub_instructions');
export const EngineStatus = new Mongo.Collection ('engineStatus');
export const EngineConnections = new Mongo.Collection ('engineConnections');
export const HubNotifications = new Mongo.Collection ('hubNotifications');
export const HubUserConnections = new Mongo.Collection ('hubUserConnections');

const DIFFUSION_USER_SESSION_KEY = 'diffusion.user_session';

function session_lecture_locale_diffusion (pVersionId)
  {
    if (typeof localStorage === 'undefined' || !pVersionId) return null;
    return localStorage.getItem ('diffusion.session.' + pVersionId) || null;
  }

function session_utilisateur_locale_diffusion ()
  {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem (DIFFUSION_USER_SESSION_KEY) || null;
  }

function pose_cookie_session_utilisateur_diffusion (pSessionId)
  {
    if (typeof document === 'undefined' || !pSessionId) return;
    document.cookie = 'diffusion_user_session_id=' + encodeURIComponent (pSessionId)
      + '; Path=/; SameSite=Lax';
  }

export function url_asset_diffusion_protegee (pUrl, pVersionId = null)
  {
    const tUrl = typeof pUrl === 'string' ? pUrl.trim () : '';
    if (!tUrl || !/^\/(?:assets|hype)\//.test (tUrl)) return tUrl || null;
    if (typeof URL === 'undefined') return tUrl;

    try
      {
        const tBase = typeof window !== 'undefined' && window.location
          ? window.location.origin
          : 'http://diffusion.local';
        const tParsed = new URL (tUrl, tBase);
        const tUserSessionId = session_utilisateur_locale_diffusion ();
        const tLectureSessionId = session_lecture_locale_diffusion (pVersionId);
        if (tUserSessionId) pose_cookie_session_utilisateur_diffusion (tUserSessionId);
        if (tUserSessionId && !tParsed.searchParams.get ('user_session_id'))
          tParsed.searchParams.set ('user_session_id', tUserSessionId);
        if (tLectureSessionId && !tParsed.searchParams.get ('session_id'))
          tParsed.searchParams.set ('session_id', tLectureSessionId);
        return tParsed.pathname + tParsed.search + tParsed.hash;
      }
    catch (e)
      {
        return tUrl;
      }
  }

HubFiles.link = function (pFichier)
  {
    if (!pFichier) return null;
    const tUrl = pFichier.url
      || pFichier.path_public
      || pFichier.path
      || (pFichier.versions && pFichier.versions.original && pFichier.versions.original.url)
      || null;
    return url_asset_diffusion_protegee (tUrl, pFichier._diffusion_version_id);
  };

export const DIFFUSION_NODE_ID = 'local';
